
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"#000","fill-opacity":".4"}}),_c('path',{attrs:{"d":"M9.364 12.364a.9.9 0 000 1.272l5.727 5.728a.9.9 0 001.273-1.273L11.273 13l5.091-5.091a.9.9 0 00-1.273-1.273l-5.727 5.728zM11 12.1h-1v1.8h1v-1.8z","fill":"#fff"}})])
          )
        }
      }
    